import type { TeacherReserveActivity, TeacherReserveAward } from '@edu-frontend/modules/src/features/teacherReserve';

/** Отсортировать активности */
export const filterAndSortActivities = (activities: TeacherReserveActivity[]) => {
    const LOW_PRIORITY_STATUSES: TeacherReserveActivity['status'][] = ['expired', 'hidden'];

    const checkCardMoveToEnd = (card: TeacherReserveActivity) => {
        const isCompleted = card.progress === card.maxProgress;
        const isLowPriorityStatus = LOW_PRIORITY_STATUSES.includes(card.status);

        return isCompleted || isLowPriorityStatus;
    };

    return activities
        .filter((card) => card.status !== 'hidden' || card.progress)
        .sort((a, b) => {
            if (checkCardMoveToEnd(a) !== checkCardMoveToEnd(b)) {
                return checkCardMoveToEnd(a) ? 1 : -1;
            }

            return a.order - b.order;
        });
};

/** Отсортировать награды сперва по level, затем по checkpoint и order */
export const sortAwards = (awards: TeacherReserveAward[]) => {
    return [...awards].sort((a, b) => {
        return a.level - b.level || (a.checkPoint || 0) - (b.checkPoint || 0) || (a.order || 0) - (b.order || 0) || 0;
    });
};
